import RichText from "@/components/RichText";
import { CONTAINER } from "../tokens";

// Les cinq domaines d'intervention : cellules séparées par des filets
// verticaux (filet bas en plus quand la grille passe sur plusieurs lignes),
// numéro Cormorant 22px or sourd, titre Cormorant 20px, description 13px.
export default function DomainsSection({ blocks = [] }) {
  const items = (blocks || []).filter((b) => b.type === "domain_item" && b.enabled !== false);
  if (!items.length) return null;

  return (
    <section className="border-t border-ink/[0.12]">
      <div className={`${CONTAINER} grid [grid-template-columns:repeat(auto-fit,minmax(190px,1fr))]`}>
      {items.map((b, i) => (
        <div
          key={b.id}
          data-block-key={b.id}
          className={`px-7 py-10 border-ink/[0.12] border-b last:border-b-0 ${i === items.length - 1 ? "" : "md:border-r"} md:border-b-0`}
        >
          <div className="font-display text-[22px] text-gold">{b.props?.number}</div>
          <RichText as="h3" className="block font-display font-normal text-[20px] leading-[1.3] text-ink mt-3.5 mb-2.5" html={b.props?.title} />
          <p className="text-[13px] leading-[1.75] font-light text-graphite m-0">{b.props?.desc}</p>
        </div>
      ))}
      </div>
    </section>
  );
}
